import { render, staticRenderFns } from "./leader_home.vue?vue&type=template&id=17c30b47&scoped=true"
import script from "./leader_home.vue?vue&type=script&lang=js"
export * from "./leader_home.vue?vue&type=script&lang=js"
import style0 from "./leader_home.vue?vue&type=style&index=0&id=17c30b47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c30b47",
  null
  
)

export default component.exports